
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/tip-calculator",
      function () {
        return require("private-next-pages/calculators/tip-calculator/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/tip-calculator"])
      });
    }
  